"use strict";

exports.__esModule = true;
var _RealtimeChart = require("./RealtimeChart");
Object.keys(_RealtimeChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RealtimeChart[key]) return;
  exports[key] = _RealtimeChart[key];
});